export const fncSetTiers = (state, payload) => {
	state.objTiers = payload;
}

export const fncEmptyTiers = (state, payload) => {
	state.objTiers = [];
}

export const fncSetBasePrice = (state, payload) => {	
	state.basePrice = payload;
}

/*export const setUserRoles = (state, payload) => {
	state.userRoles = Object.values(payload);	
}

export const setRoleId = (state, payload) => {
	state.roleId = payload;
}

export const setObjRoleEdit = (state, payload) => {
	var roleId = payload;	
	for( var k in state.userRoles ) {
		if( state.userRoles[k].id === roleId ) {			
			state.objRoleEdit = state.userRoles[k];
			if( state.objRoleEdit.active === 'No' ) {
				state.objRoleEdit.active = false;
			} else if( state.objRoleEdit.active === 'Yes' ) {
				state.objRoleEdit.active = true;
			}
		}
	}	
}

export const setObjRolePlists = (state, payload) => {	
	state.objRolePlists = payload;
}

export const setObjRolePrivs = (state, payload) => {	
	state.objRolePrivs = [];
	for( var k in payload.available ) {
		if( payload.assigned.indexOf(payload.available[k].id ) !== -1 ) {
			payload.available[k].privActive = true;			
		} else {
			payload.available[k].privActive = false;			
		}
	}
	state.objRolePrivs = payload.available;
}

export const setObjManuPlists = (state, payload) => {		
	state.objManuPlists = payload;	
	for( var k in state.objManuPlists) {
		var plistId = parseInt(state.objManuPlists[k].pl_id);
		if (state.objRolePlists.indexOf(plistId) !== -1) {			
			state.objManuPlists[k].pl_active = true;
		} else {
			state.objManuPlists[k].pl_active = false;
		}
	}
}

export const setPrivStatus = (state, payload) => {
	var objRolePrivs = [];
	for( var k in state.objRolePrivs ) {			
		if( state.objRolePrivs[k].id === payload.privId ) {			
			state.objRolePrivs[k].active = payload.privStatus;	
			objRolePrivs.push(state.objRolePrivs[k]); 
		} else {
			objRolePrivs.push(state.objRolePrivs[k]); 
		}
	}	
	state.objRolePrivs = objRolePrivs.reverse();
}

export const fncSetRoles = (state, payload) => {
	state.userRoles = [];	
}

export const fncResetRoles = (state, payload) => {	
	state.userRoles.splice(payload.newIndex, 0, state.userRoles.splice(payload.oldIndex, 1)[0]);
	for ( var k in state.userRoles ) {
		state.userRoles[k].level = parseInt(k) + 1
	}	
}

export const fncEmptyRoles = (state, payload) => {
	state.userRoles = [];
}*/